import { useState, useEffect } from 'react';

/**
 * Custom hook to manage token from URL params and session storage
 */
export const useTokenManager = () => {
  const [hasAccessToken, setHasAccessToken] = useState(
    !!sessionStorage.getItem('AccessToken')
  );
  const [jwt, setJwt] = useState(null);

  useEffect(() => {
    const url = new URL(window.location.href);
    const tokenHeader = url?.searchParams.get('token');
    const refreshToken = url?.searchParams.get('refreshToken');

    if (tokenHeader) {
      sessionStorage.setItem('AccessToken', tokenHeader);
      setHasAccessToken(true);
    }
    
    if (refreshToken) {
      sessionStorage.setItem('RefreshToken', refreshToken);
    }

    const currentJwt = tokenHeader || sessionStorage.getItem('AccessToken');
    setJwt(currentJwt);

    window.onpopstate = () => {
      // Handle browser back button
    };
  }, []);

  return { hasAccessToken, setHasAccessToken, jwt };
};
